import React, { Component, Fragment } from 'react'

import Helmet from 'react-helmet'

import Footer from './footer'

import Hero from './hero'
import ChiSono from './chisono'
import Portfolio from './portfolio'
import Faq from './faq'
import Contatti from './contatti'
import Mappa from './mappa'
import Gdpr from './gdpr'

class LayoutOrizzontale extends Component {
    constructor(props) {
        super(props)
        this.state = ({
            enableAnal: null,
        })
    }

    componentDidMount() {
        this.setState({ enableAnal: localStorage.getItem('Prowedding_analytics') ? JSON.parse(localStorage.getItem('Prowedding_analytics')) : null })
    }

    render() {

        return (
            <Fragment>

                <Helmet>

                    <title>{this.props.sito.titolo} - Prowedding</title>
                    <meta name="description" content={this.props.sito.descrizione} />
                    
                    {/*
                    <meta name="image" content={image} />

                   
                    <script type="application/ld+json">
                        {JSON.stringify(schemaOrgJSONLD)}
                    </script>

                    
                    
                    <meta property="og:type" content="article" />
                    */}
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:title" content={this.props.sito.titolo} />
                    <meta property="og:description" content={this.props.sito.descrizione} />
                    <meta property="og:image" content={this.props.sito.cover} />
                    
{/*
                    <meta property="fb:app_id" content={config.fbAppID} />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:creator" content={config.twitter} />
                    <meta name="twitter:title" content={title} />
                    <meta name="twitter:description" content={description} />
                    <meta name="twitter:image" content={image} />
               */}

                    <script>
                        {`
									(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
									(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
									m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
									})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
	
									window['ga-disable-${this.props.sito.codice}'] = ${!this.state.enableAnal};

									ga('set', 'anonymizeIp', true);
									ga('create', '${this.props.sito.codice}', 'auto');
									ga('send', 'pageview');
								`}
                    </script>


                </Helmet>

                <Hero user={this.props.user} sito={this.props.sito} />
                <ChiSono user={this.props.user} sito={this.props.sito} />
                <Portfolio sito={this.props.sito} />
                <Faq sito={this.props.sito} />
                <Contatti user={this.props.user} sito={this.props.sito} />
                <Mappa user={this.props.user} sito={this.props.sito} />
               
                <Footer user={this.props.user} />
                <div>
                <Gdpr user={this.props.user}/>
                </div>
                

            </Fragment>
        )
    }

}
export default LayoutOrizzontale


// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/index.js